
<script>
import Cookies from 'js-cookie'
import {hdxCordova} from '@/mocean.js';
// Logout 정의 부분
// 유저 정보와 토큰을 삭제한 이후, 화면을 재갱신한다.
// 자동적으로 /login 화면으로 이동
export default {
  name: 'logout',
  created () {
    // this.$store.dispatch('user/Logout').then(() => {
    const confirmMessage = window.__cordova_platform !== 'browser'
        ? 'Do you want to close the app (앱을 종료하시겠습니까)?'
        : 'Do you want to log out (로그아웃 하시겠습니까)?';

      if (confirm(confirmMessage)) {
        if (window.__cordova_platform !== 'browser') {
          window.moceanObj.executeExitWebBrowser();
          sessionStorage.setItem('userId', '');
        } else {  
          // console.log('login', this.$router)
          Cookies.remove('pp_savepw')
          Cookies.remove('pp_rem')
          this.$router.push('/login')
        }
      }else{
        Cookies.remove('pp_savepw')
        Cookies.remove('pp_rem')
        this.$router.push('/v20Menu')
      }

    // })
  },
  render: (h) => h()
}
</script>
